import styled, { css } from 'styled-components';

import { tokens } from '../../tokens';
import { NftCardSectionVariant } from '../../types';

interface StyledSectionProps {
    $variant?: NftCardSectionVariant;
}

const commonBase = css`
    padding-right: ${tokens.card.padding}px;
    padding-left: ${tokens.card.padding}px;
`;

export const StyledSection = styled.div<StyledSectionProps>`
    ${({ $variant }) => {
        if ($variant === NftCardSectionVariant.Common) {
            return commonBase;
        }

        if ($variant === NftCardSectionVariant.Hero) {
            return css`
                ${commonBase};
                padding-top: ${tokens.card.padding}px;
            `;
        }

        if ($variant === NftCardSectionVariant.Credits) {
            return css`
                ${commonBase};
                margin-top: ${tokens.card.padding * -1}px;
                margin-bottom: ${tokens.card.padding * -1}px;
            `;
        }

        if ($variant === NftCardSectionVariant.Activity) {
            return css`
                ${commonBase};
                display: grid;
                flex: 1 1 auto;
                padding-bottom: ${tokens.card.padding}px;
            `;
        }
    }};
`;
